<div
  *ngIf="typeQr == typeQrData.Basic"
  [ngStyle]="{ width: width + 'px' }"
  class="qr"
  (mouseenter)="isShowDown = true"
  (mouseleave)="isShowDown = false"
>
  <qrcode
    #UrlQR
    [qrdata]="contentQR"
    [width]="width"
    [errorCorrectionLevel]="'M'"
    [allowEmptyString]="true"
    [colorDark]="colorQR"
    [colorLight]="colorBackground"
    elementType="img"
    [scale]="scale"
    [margin]="margin"
    [cssClass]="cssClass"
  ></qrcode>
  <button
    *ngIf="isShowDown"
    (click)="saveAsImage(UrlQR)"
    nbButton
    status="success"
    size="tiny"
  >
    <nb-icon icon="download-outline"></nb-icon>
  </button>
</div>

<div
  *ngIf="typeQr == typeQrData.Advanced"
  [ngStyle]="{ width: width + 'px' }"
  class="qr"
  (mouseenter)="isShowDown = true"
  (mouseleave)="isShowDown = false"
>
  <ngx-qrcode-styling [config]="config"></ngx-qrcode-styling>
</div>
